// Individual export should be used within oasis-core
export const DASHBOARD_SERVICE_URL = "/api/Dashboard/";
export const MANAGEMENT_SERVICE_URL = "/api/Management/";
export const AUTHCENTRAL_SERVICE_URL = "/api/AuthCentral/";
export const DOCUMENTSTORE_SERVICE_URL = "/api/DocumentStore/";
export const DOCUMENTSEARCH_SERVICE_URL = "/api/DocumentSearch/";
export const INITIALIZATION_SERVICE_URL = "/api/Initialization/";

// export const DOCUMENTSTORE_SERVICE_URL = "http://localhost:49925/";
// export const MANAGEMENT_SERVICE_URL = "http://localhost:5634/";
// export const DOCUMENTSEARCH_SERVICE_URL = "http://localhost:5389/";
// export const AUTHCENTRAL_SERVICE_URL = "https://localhost:44350/";
// export const WORKFLOW_SERVICE_URL = "http://localhost:3445/";

// Bundled consts should be used by apps consuming oasis-core
export default {
  DASHBOARD_SERVICE_URL,
  MANAGEMENT_SERVICE_URL,
  AUTHCENTRAL_SERVICE_URL,
  DOCUMENTSTORE_SERVICE_URL,
  DOCUMENTSEARCH_SERVICE_URL,
  INITIALIZATION_SERVICE_URL,
};